import SeoTitle from '@/components/SeoTitle';
import PageJsonLd from './components/PageJsonLd';
import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import ClusterLinksSection from './components/ClusterLinksSection';
import WhatAreCompetencies from './components/WhatAreCompetencies';
import KeyCompetencies from './components/KeyCompetencies';
import WhyTrainingNotEnough from './components/WhyTrainingNotEnough';
import DiagnosisZones from './components/DiagnosisZones';
import CompetencyMatrix from './components/CompetencyMatrix';
import SuitableFor from './components/SuitableFor';
import HowProgramGoes from './components/HowProgramGoes';
import FormatsSection from './components/FormatsSection';
import WhyProgramsWork from './components/WhyProgramsWork';
import CompanyResults from './components/CompanyResults';
import AboutTrainer from './components/AboutTrainer';
import RelatedClusters from './components/RelatedClusters';
import ReadNextSection from './components/ReadNextSection';
import FAQSection from './components/FAQSection';
import FinalCTA from './components/FinalCTA';
import RoiCtaStrip from '@/components/feature/RoiCtaStrip';
import Footer from '@/components/feature/Footer';

const navLinks = [
  { label: 'Навыки', target: 'skills' },
  { label: 'Программа', target: 'process' },
  { label: 'Результаты', target: 'results' },
  { label: 'FAQ', target: 'faq' },
];

export default function ManagementCompetenciesPage() {
  return (
    <>
      
      <SeoTitle title="Развитие управленческих компетенций | Business Training" />
      <PageJsonLd />

      <div className="min-h-screen bg-white font-['Inter']">
        <Navbar
          links={navLinks}
          ctaLabel="Заказать тренинг"
          ctaTarget="contact"
        />
        <HeroSection />
        <ClusterLinksSection />
        <WhatAreCompetencies />

        <div id="skills">
          <KeyCompetencies />
        </div>

        <WhyTrainingNotEnough />
        <DiagnosisZones />
        <CompetencyMatrix />
        <SuitableFor />

        <div id="process">
          <HowProgramGoes />
        </div>

        <FormatsSection />
        <WhyProgramsWork />

        <div id="results">
          <CompanyResults />
        </div>

        <AboutTrainer />
        <RelatedClusters />
        <RoiCtaStrip />
        <ReadNextSection />
        <FAQSection />
        <FinalCTA />
        <Footer />
      </div>
    </>
  );
}